import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";
import { formatViews } from "@/utils/movies";

type PopularSidebarProps = {
  movies: Movie[];
};

export default function PopularSidebar({ movies }: PopularSidebarProps) {
  return (
    <aside className="w-full lg:w-[320px]">
      <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
        <div className="mb-4 flex items-center gap-2">
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-100 text-primary-700">
            <i className="ri-fire-line" />
          </span>
          <h2 className="font-heading text-lg font-bold text-foreground-950">
            热门推荐
          </h2>
        </div>

        <ol className="flex flex-col">
          {movies.map((movie, i) => (
            <li key={movie.id}>
              <Link
                to={`/detail/${movie.id}`}
                className="group flex items-center gap-3 rounded-md py-2.5 transition-colors hover:bg-background-100"
              >
                <span
                  className={`flex h-6 w-6 flex-none items-center justify-center rounded-md text-xs font-bold ${
                    i < 3
                      ? "bg-accent-500 text-primary-950"
                      : "bg-background-200 text-foreground-600"
                  }`}
                >
                  {i + 1}
                </span>
                <div className="h-14 w-10 flex-none overflow-hidden rounded-md bg-background-200">
                  <img
                    src={movie.cover}
                    alt={`${movie.title}封面`}
                    title={`${movie.title} - 日韩伦理片热门推荐`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <h3 className="truncate text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-700">
                    {movie.title}
                  </h3>
                  <div className="mt-1 flex items-center gap-2 text-[11px] text-foreground-500">
                    <span className="flex items-center gap-0.5 text-accent-600">
                      <i className="ri-star-fill" />
                      {movie.rating.toFixed(1)}
                    </span>
                    <span className="flex items-center gap-0.5">
                      <i className="ri-eye-line" />
                      {formatViews(movie.views)}
                    </span>
                  </div>
                </div>
              </Link>
            </li>
          ))}
        </ol>
      </div>

      <div className="mt-4 rounded-lg border border-primary-200 bg-primary-50 p-4 md:p-5">
        <h3 className="font-heading text-base font-semibold text-primary-800">
          找不到想看的？
        </h3>
        <p className="mt-2 text-sm leading-relaxed text-foreground-700">
          试试按地区、年份或类型精准筛选，快速定位属于你的那一部好片。
        </p>
        <Link
          to="/category"
          className="mt-4 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-filter-3-line" />
          去分类筛选
        </Link>
      </div>
    </aside>
  );
}